// document.addEventListener("DOMContentLoaded", (event) => {
//   var colTitles = document.querySelectorAll('.collection-menu-items .collection-item-title')
//   colTitles.forEach(function (item) {
//     item.addEventListener("mouseover", function () {
//       item.classList.remove('active');
//       this.classList.add('active');
//       var dataId = this.dataset.id

//       var itemWrapper = document.querySelector('#'+dataId)
//       document.querySelectorAll('.collection-product-main .media-card').forEach(function() {
//         console.log('this:>',this)
//         this.classList.add('hide');
//       });
//       itemWrapper.classList.remove('hide');
//     });
//   });
// });
$(document).ready( function () {
  $(document).on('mouseenter','.collection-item-title', function() {
    $('.collection-item-title').removeClass('active')
    $(this).addClass('active');
    
    var dataId = $(this).data('id')
    $('.collection-product-main .media-card').addClass('hide')
    // console.log('DIV::',$('#'+dataId))
    $('#'+dataId).removeClass('hide');    
  })

  $('.product__title .jdgm-widget .jdgm-prev-badge').on('click', function(){
    if($('.product__accordion.reviews[aria-expanded="true"]').length == 0){
      $('.product__accordion.reviews summary').trigger('click');      
    }
    setTimeout( ()=> {
      var elementOffset = $('.product__accordion.reviews summary').offset().top - 150;      
      $('html, body').animate({ scrollTop: elementOffset }, 500);
    })
  })
})